<template>
  <van-overlay :show="visible" :lock-scroll="false">
    <div ref="popupRef" class="popup" @click.stop>
      <!-- <div class="main-bg"> -->
      <div ref="boxRef" class="contain-box">
        <div class="popup-main-close">
          <van-icon
            @click="clickClose"
            name="close"
            color="white"
            size="30px" />
        </div>
        <div ref="titleRef" class="title">
          {{ title || "" }}
        </div>
        <div class="content-box">
          <div class="content" v-html="content"></div>
        </div>
        <div class="sure-bg" @click="clickSure">{{ btnTitle }}</div>
      </div>
      <!-- </div> -->
    </div>
  </van-overlay>
</template>
    
    <script>
import { Icon, Overlay } from "vant"
export default {
  name: "BaseOneButtonPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    content: {
      type: String,
      default: undefined
    },
    btnTitle: {
      type: String,
      default: "确定"
    }
  },
  data() {
    return {}
  },
  created() {
    this.$nextTick(() => {
      let popupHeight = this.$refs.popupRef.offsetHeight
      let boxHeight = this.$refs.boxRef.offsetHeight
      if (boxHeight > popupHeight) {
        this.$refs.popupRef.style.justifyContent = "left"
        this.$refs.titleRef.style.marginTop = "220px"
      }
    })
  },
  methods: {
    clickClose() {
      this.$emit("onClose", "update:visible", false)
      this.$emit("onCloseClick")
    },
    clickSure() {
      this.$emit("update:visible", false)
      this.$emit("onSureClick")
    }
  }
}
</script>
    
    <style lang="less" scoped>
.van-overlay {
  z-index: 100;
}
.popup {
  margin-left: 10px;
  width: calc(100vw - 20px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  .contain-box {
    position: relative;
    background-image: url("../assets/img/my-redpack/anniversary/anniversary_pop_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    width: 100%;
    .popup-main-close {
      position: absolute;
      top: 20px;
      right: 15px;
    }
    .title {
      text-align: center;
      margin: 120px 20px 0 30px;
      color: rgb(251, 244, 225);
      font-size: 22px;
      font-weight: 900;
      text-shadow: 2px 2px 5px rgb(189, 150, 136);
    }
    .content-box {
      margin: 20px 30px 0 30px;
      border: 3px solid rgb(199, 144, 54);
      border-radius: 20px;
      background-color: white;
      .content {
        line-height: 30px;
        text-align: left;
        text-align-last: left;
        color: rgb(149, 148, 146);
        font-size: 16px;
        font-weight: 900;
        padding: 20px;
      }
    }
    .sure-bg {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 50px;
      margin: 20px 30px 15px 30px;
      border-radius: 25px;
      background-color: white;
      text-align: center;
      color: rgb(215, 173, 102);
      font-size: 25px;
      -moz-box-shadow: 2px 2px 5px rgb(155, 155, 155);
      -webkit-box-shadow: 2px 2px 5px rgb(155, 155, 155);
      box-shadow: 2px 2px 10px rgb(155, 155, 155);
    }
  }
}
</style>